import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * ChangePasswordView class for handling password change functionality.
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section for new password input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Input field for new password
                    name: 'NewPassword',
                    type: 'password',
                    id: 'NewPassword',
                    label: _('Nueva Contraseña'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _(
                        'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.',
                    ), // Error message for invalid input
                    validate: function (value) {
                        // Validation function for password strength
                        return value.length >= 8 && /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value);
                    },
                    on: {
                        onBlur: function () {
                            // Validate on blur event
                            $$('NewPassword').validate();
                        },
                    },
                },
            ],
        };

        // Right section for confirm password input
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Input field for confirming password
                    name: 'ConfirmPassword',
                    type: 'password',
                    id: 'ConfirmPassword',
                    label: _('Confirmar Contraseña'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Contraseñas no coinciden'), // Error message for mismatch
                    validate: function (value) {
                        // Validation function for password confirmation
                        return value == $$('NewPassword').getValue();
                    },
                    on: {
                        onBlur: function () {
                            // Validate on blur event
                            $$('ConfirmPassword').validate();
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Upper section layout containing password fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [
                        center_left, // Left section
                        right, // Right section
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        // Clear form values and validation
                        $$('formChangePassword').setValues($$('formChangePassword').getCleanValues());
                        $$('formChangePassword').clearValidation();
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Handle save action
                        var vthis = this;
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newPassword = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            if (
                                newPassword.NewPassword === newPassword.ConfirmPassword // Check if passwords match
                            ) {
                                webix.confirm({
                                    type: 'confirm-warning',
                                    text: _('Advertencia!') + '<br/>' + _('Desea cambiar la contraseña?'), // Confirmation message
                                    ok: _('Cambiar Contraseña'),
                                    cancel: _('Salir'),
                                    callback: function (action) {
                                        // Callback for confirmation
                                        if (action === true) {
                                            const data = {
                                                ClientId: cur_user, // Client ID
                                                Password: newPassword.NewPassword, // New password
                                                ConfirmPassword: newPassword.ConfirmPassword, // Confirm password
                                            };
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/ResetPassword', // API endpoint for password reset
                                                    data,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {}, // Error handling
                                                        success: function (text, data, XmlHttpRequest) {
                                                            // Success handling
                                                            var json = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (json.HasError) {
                                                                // Check for errors in response
                                                                if (json.CodeError != 110012) {
                                                                    webix.message({
                                                                        text: json.AlertMessage, // Show error message
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                    });
                                                                }
                                                            } else {
                                                                webix.message({
                                                                    text: _(
                                                                        'Contraseña cambiada satisfactoriamente', // Success message
                                                                    ),
                                                                    title: _('¡Exito!'),
                                                                    type: 'alert-warning',
                                                                });
                                                                $$('formChangePassword').setValues(
                                                                    $$('formChangePassword').getCleanValues(), // Clear form values
                                                                );
                                                                $$('formChangePassword').clearValidation(); // Clear validation
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    title: '¡Error!',
                                    type: 'alert-error',
                                    text: _('Contraseñas no coinciden'), // Error message for password mismatch
                                });
                            }
                        } else {
                            webix.message({
                                title: '¡Error!',
                                type: 'alert-error',
                                text: _('Completa los campos...'), // Error message for incomplete fields
                            });
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formChangePassword', // Form ID
            rows: [upper_section, buttons], // Form layout
        };
    }
}

// FILE DOCUMENTED
